import React, { useState, useEffect } from 'react';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import {
    Await,
    defer,
    Form,
    useLoaderData,
} from "react-router-dom";
import { getClients } from "../../../data/loca/clients";

const normalizePhoneSearchValue = (value) => {
    if (!value) {
        return '';
    }

    const trimmedValue = value.trim();
    const isPhoneLikeValue = /^[\d\s.+()-]+$/.test(trimmedValue) && /\d/.test(trimmedValue);

    if (!isPhoneLikeValue) {
        return value;
    }

    let normalizedValue = trimmedValue.replace(/[\s.()-]/g, '');

    if (normalizedValue.startsWith('+33')) {
        normalizedValue = `0${normalizedValue.slice(3)}`;
    } else if (normalizedValue.startsWith('0033')) {
        normalizedValue = `0${normalizedValue.slice(4)}`;
    }

    return normalizedValue.replace(/\D/g, '');
};

export async function loader({ params }) {
     
    const clients =  getClients();
    return defer({
        clients: clients,
    });

}
export default function ClientsList() {
 
    const  data  = useLoaderData();
    const [filters, setFilters] = useState(null);
    const [loading] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    useEffect(() => {
        
        initFilters();
    }, []);

    const onGlobalFilterChange = (e) => {
        const value = normalizePhoneSearchValue(e.target.value);
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'country.name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            representative: { value: null, matchMode: FilterMatchMode.IN },
            date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
            balance: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            status: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            activity: { value: null, matchMode: FilterMatchMode.BETWEEN },
            verified: { value: null, matchMode: FilterMatchMode.EQUALS }
        });
        setGlobalFilterValue('');
    };

    const renderHeader = () => {
        return (
            <div className="tools-list-toolbar clients-list-toolbar">
                <span className="p-input-icon-left tools-list-search">
                    <i className="pi pi-search" />
                    <InputText id="searchClients" value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Rechercher un client..." />
                </span>

                <Form className="tools-list-add-button" method="get" action="/clients/ajout" >
                    <Button icon="pi pi-user-plus" type="submit" size="small">Ajouter un client</Button>
                </Form>
            </div>
        );
    };


    const nameBodyTemplate = (rowData) => {
        const initials = `${rowData.firstname?.[0] || ''}${rowData.lastname?.[0] || ''}`.trim() || '?';

        return (
            <div className="tools-list-name-cell clients-list-name-cell">
                <span className="clients-list-avatar">{initials.toUpperCase()}</span>
                <span>
                    <b>{[rowData.firstname, rowData.lastname].filter(Boolean).join(" ") || "Client sans nom"}</b>
                    <small>{rowData.email || "Email non renseigné"}</small>
                </span>
            </div>
        );
    };

    const contactBodyTemplate = (rowData) => {
        return (
            <div className="clients-list-contact-cell">
                <span>{rowData.email || "—"}</span>
                <small>{rowData.phone || "Téléphone non renseigné"}</small>
            </div>
        );
    };

    const phoneBodyTemplate = (rowData) => {
        return <span className="clients-list-phone">{rowData.phone || "—"}</span>;
    };

    const selectedClient = (rowData) => {
        window.location.href = `/clients/${rowData.publicId}`;
    };

    const header = renderHeader();
    return (
        <div className="tools-list-page clients-list-page">
            <div className="tools-list-page-header">
                <div className="tools-list-page-title">
                    <i className="pi pi-users"></i>
                    <div>
                        <p className="tools-list-kicker">Clients</p>
                        <h1>Liste des clients</h1>
                        <p>Retrouvez, filtrez et administrez les contacts liés à vos locations.</p>
                    </div>
                </div>
            </div>

            <React.Suspense
                fallback={
                    <div className="card flex justify-content-center">
                    <ProgressSpinner />
                </div>}
            >
                <Await
                    resolve={data.clients}
                    errorElement={
                        <p>Aucun client n'a été trouvé, ou ne fait pas partie de votre abonnement.</p>
                    }
                >
                    {(clients) => (
                        <div className="tools-list-card clients-list-card">
                            <DataTable className="tools-list-table clients-list-table" selectionMode="single" onSelectionChange={(e) => selectedClient(e.value)} value={clients.map((client) => ({ ...client, phoneSearch: normalizePhoneSearchValue(client.phone) }))} paginator rows={20} loading={loading} dataKey="id" filters={filters} globalFilterFields={['firstname', 'lastname', 'email', 'phone', 'phoneSearch', 'additionalContactsSearchText']} header={header} emptyMessage="Aucun client trouv&eacute;">
                                <Column header="Client" body={nameBodyTemplate} />
                                <Column header="Contact" body={contactBodyTemplate} headerClassName="clients-list-contact-column" className="clients-list-contact-column" />
                                <Column field="phone" header="Téléphone" body={phoneBodyTemplate} headerClassName="tools-list-mobile-hidden" className="tools-list-mobile-hidden" />

                            </DataTable>
   

                        </div>
                    )}
                </Await>
            </React.Suspense>

            
        </div>
    );
}
